// "Ask Copilot": a round floating button at the bottom right of every page, where
// the panel opens, so it never competes with the sidebar's navigation. Hidden
// while the panel is open (the panel has its own close). Shown to the same
// people as the full Copilot page, which stays its own menu entry.
import React from "react";
import { Tooltip } from "antd";
import { useLocation } from "react-router-dom";
import { useCopilot } from "./CopilotContext";
import { Launcher } from "./CopilotPanelStyle";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "");
const SHORTCUT = isMac ? "⌘J" : "Ctrl+J";

const CopilotLauncher = () => {
  const { allowed, toggle } = useCopilot();
  const { pathname } = useLocation();
  // Not on the full Copilot page itself (Ctrl/Cmd+J still works there).
  if (!allowed || pathname.startsWith("/operator")) return null;
  return (
    <Tooltip title={`Ask Copilot (${SHORTCUT})`} placement="left">
      <Launcher id="copilot-launcher" type="button" onClick={toggle}
        aria-label="Ask Copilot" aria-keyshortcuts={isMac ? "Meta+J" : "Control+J"}>
        <img src="/images/ai-icon.svg" alt="" />
      </Launcher>
    </Tooltip>
  );
};

export default CopilotLauncher;
